export default import.meta.ROLLDOWN_FILE_URL_6w9n0zAwOT6o4YSEhOTCAQ